import { Button } from '~/components/button'
import type { PaginationItemProps } from '../../pagination.types'
import { paginationItemVariants } from './index.styles'

export const PaginationItem: React.FC<PaginationItemProps> = ({
  children,
  hasCurrent,
  href,
  item,
  testID,
  ...props
}) => {
  return (
    <li className={paginationItemVariants({ hasCurrent })}>
      <a
        data-testid={testID}
        {...(href ? { href } : {})}
        aria-label={`Página ${item}`}
        aria-current={hasCurrent}
      >
        <Button.Root
          {...props}
          type="button"
          variant={'neutral-tertiary'}
          size="lg"
          data-active={hasCurrent}
          className="data-[active=true]:bg-action-fill-neutral-tertiary-activated"
        >
          {item}
        </Button.Root>
      </a>
    </li>
  )
}
